<template>
  <div class="benefit">
    <div v-for="(item) in benefitContent" :key="item.id">
      <p class="question">{{item.question}}</p>
      <p v-for="(answer, index) in item.answer" :key="index"  class="answer">{{answer}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'benefit',
  props:{
    benefitContent:{
      type:Array,
      default(){
        return []
      }
    }
  }
}
</script>
<style lang="scss">
.benefit {
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    padding: .32rem;
    padding-top: 0.4rem;
    background: #fff;
    div{
        margin-bottom: .2rem;
        .question {
            font-family: PingFangSC-Regular;
            font-size: .32rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing:0rem;
            color: #161616;
            margin-bottom: .18rem;
        }
        .answer {
            font-family: PingFangSC-Regular;
            font-size: .30rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: .45rem;
            letter-spacing:0rem;
            color: #919294;
        }          
    }
  
}   
    
      /*iPhone X XS 2436x1125px at 458ppi */
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .common-problems {
        padding-top: 2.24rem;
    }
  }

  /*iPhone XR 1792x828px at 326ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .common-problems {
        padding-top: 2.24rem;
    }
  }

  /* iPhone XS Max 2688x1242px at 458ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .common-problems {
        padding-top: 2.24rem;
    }
  }
</style>